import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

export const OpportunityCalculatorGrid = styled.div`
  display: grid;
  width: 100%;
  max-width: 1220px;
  column-gap: 2rem;
  grid-template-columns: 1fr 520px;

  ${applyStylesToMobileExperience(css`
    grid-template-columns: 1fr;
    row-gap: 2rem;
    width: auto;
    max-width: 560px;
  `)}
`;

export const OpportunityCalculatorTextBlock = styled.div`
  display: grid;
  align-self: center;
  row-gap: 2rem;
  max-width: 558px;

  ${applyStylesToMobileExperience(css`
    padding: 0 1.5rem;
    justify-self: center;
    max-width: 520px;

    .opportunity-calculator-heading {
      text-align: center;
    }
    .opportunity-calculator-paragraph {
      text-align: center;
    }
  `)}
`;

export const OpportunityCalculatorFeatureChipsBlock = styled.div`
  justify-self: start;
  display: grid;
  row-gap: 0.5rem;

  ${applyStylesToMobileExperience(css`
    justify-self: stretch;
  `)}

  @media all and (max-width: ${layout.sm}) {
    display: none;
  }
`;

export const OpportunityCalculatorFeatureChip = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  column-gap: 0.5rem;
  justify-self: start;
  padding: 0.5rem 1rem;
  border-radius: 16px;
  // Background transparency not in palette
  background-color: rgba(223, 207, 189, 0.5);

  ${applyStylesToMobileExperience(css`
    justify-self: stretch;
  `)}
`;
